import { useRouteMatch } from 'react-router';
import { get } from 'lodash';
import { BASE_FORM_ROUTE_PATH, PATH_TO_FORM_MODE_MAP } from 'config/routes';
import { useMultiLayerPathParams } from '../modules/taboola-common-frontend-modules/multi-layer-drawer/hooks/useMultiLayerPathParams';

export const useFormMode = () => {
    const routeMatch = useRouteMatch(BASE_FORM_ROUTE_PATH);
    const modeMatch = get(routeMatch, 'params.mode');
    const { mode: modePath } = useMultiLayerPathParams();

    const mode = modePath || modeMatch;

    return PATH_TO_FORM_MODE_MAP[mode] || mode;
};
